import React from "react";

const LocationIcon = ({ height = 11.949, width = 8.962 }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 8.962 11.949"
      >
        <path
          id="map-marker-alt-solid_1_"
          data-name="map-marker-alt-solid (1)"
          d="M4.02,11.708C.629,6.792,0,6.288,0,4.481a4.481,4.481,0,0,1,8.962,0c0,1.807-.629,2.311-4.02,7.227a.56.56,0,0,1-.921,0Zm.461-5.36A1.867,1.867,0,1,0,2.614,4.481,1.867,1.867,0,0,0,4.481,6.348Z"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default LocationIcon;
